<script>
  import { style, blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;
</script>

<section style="{style(block)}">
  <div class="container">
    <div class="row">
      <div class="col-8 mx-auto text-center mb-5">
        <span class="badge rounded-pill badge-primary mb-2">{text(block, 'tag')}</span>
        <h1>{text(block, 'headline')}</h1>
        <p style="font-size: 1.5em;">
          {@html richtext(block, 'body')}
        </p>
      </div>
    </div>
  </div>
</section>
